import { CommonModule, DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DatePipe } from "@progress/kendo-angular-intl";
import { SortImportFieldsPipe } from "./pipes/sortImportFields.pipe";
import { ReportArgusSyncDialogComponent } from "./report-argus-sync-dialog/report-argus-sync-dialog.component";
import { ImportPreviewRenderService } from "./services/import-preview-render-service";
import { StepsManagerComponent } from "./steps-manager/steps.manager.component";
import { SvgIconComponent } from "./svg-icon/svg-icon.component";
import { ToggleItemComponent } from './toggle-item/toggle-item.component';
import { WindowModule, DialogsModule } from "@progress/kendo-angular-dialog";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { UploadsModule } from '@progress/kendo-angular-upload';
import { ListViewModule } from "@progress/kendo-angular-listview";
import { ArgusDialogComponent } from "./argus-dialog/argus-dialog.component";
import { HighlightDirective } from './highlight.directive';
import { ReflistPipe } from "./pipes/refList.pipe";
import { PictureUploadComponent } from "./picture-upload/picture-upload.component"
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppConfirmDialogComponent } from "./confirm-dialog/app-confirm-dialog.component";
import { LoadingIndicatorComponent } from "./loader-spinner/loading-indicator-component";
import { PagerModule } from "@progress/kendo-angular-pager"
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AppImportDialogComponent } from "../common/app-import-dialog/app-import-dialog.component";
import { AppendTextPipe } from "./pipes/appendText.pipe";
import { MultiplyByPipe } from "./pipes/multiplyBy.pipe";
import { PropertiesFormComponent } from "./forms/properties-form/properties-form.component";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { DataLoaderComponent } from "./data-loader/data-loader.component";
import { AssignPropertiesDialogComponent } from './assign-properties-dialog/assign-properties-dialog.component';
import { GridModule } from "@progress/kendo-angular-grid";
import { ConfirmDeleteDialogComponent } from "./dialogs/confirm-delete-dialog/confirm-delete-dialog.component";

/**
 * Common module
 */
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        WindowModule,
        ButtonsModule,
        InputsModule,
        UploadsModule,
        ListViewModule,
        FormsModule,
        DropDownsModule,
        PagerModule,
        DialogsModule,
        ReactiveFormsModule,
        DateInputsModule,
        GridModule
    ],
    exports: [
        SvgIconComponent,
        ToggleItemComponent,
        StepsManagerComponent,
        SortImportFieldsPipe,
        DataLoaderComponent,
        ReportArgusSyncDialogComponent,
        ArgusDialogComponent,
        HighlightDirective,
        ReflistPipe,
        PictureUploadComponent,
        AppConfirmDialogComponent,
        LoadingIndicatorComponent,
        AppImportDialogComponent,
        AppendTextPipe,
        MultiplyByPipe,
        PropertiesFormComponent,
        ConfirmDeleteDialogComponent,
        AssignPropertiesDialogComponent
    ],
    declarations: [
        AppConfirmDialogComponent,
        SvgIconComponent,
        ToggleItemComponent,
        StepsManagerComponent,
        SortImportFieldsPipe,
        DataLoaderComponent,
        ReportArgusSyncDialogComponent,
        ArgusDialogComponent,
        HighlightDirective,
        ReflistPipe,
        PictureUploadComponent,
        LoadingIndicatorComponent,
        AppImportDialogComponent,
        AppendTextPipe,
        MultiplyByPipe,
        PropertiesFormComponent,
        ConfirmDeleteDialogComponent,
        AssignPropertiesDialogComponent
    ],
    providers: [
        DecimalPipe,
        DatePipe,
        SortImportFieldsPipe,
        ImportPreviewRenderService
    ]
})
export class AppCommonModule { }
